import { createRouter, createWebHistory } from 'vue-router';
import DefaultLayout from '../layouts/DefaultLayout.vue';
import Home from '../views/Home.vue';
import About from '../views/About.vue';
import Contact from '../views/Contact.vue';
import Shop from '../views/pages/shop.vue';
import Cart from '../views/pages/cart.vue';
import Checkout from '../views/pages/checkout.vue';
import Login from '../views/pages/login.vue';
import MyAccount from '../views/pages/my-account.vue';
import MyOrder from '../views/pages/my-orders.vue';
import MyAddress from '../views/pages/my-address.vue';

const routes = [
  {
    path: '/',
    component: DefaultLayout,
    children: [
      {
        path: '',
        name: 'Home',
        component: Home,
      },
      {
        path: 'about',
        name: 'About',
        component: About,
      },
      {
        path: 'shop',
        name: 'shop',
        component: Shop,
      },
      {
        path: 'cart',
        name: 'Cart',
        component: Cart,
      },
      {
        path: 'checkout',
        name: 'Checkout',
        component: Checkout,
      },
      {
        path: 'login',
        name: 'login',
        component: Login,
      },
      {
        path: 'my-account',
        name: 'MyAccount',
        component: MyAccount,
      },
      {
        path: 'my-orders',
        name: 'myOrders',
        component: MyOrder,
      },
      {
        path: 'my-address',
        name: 'myAddress',
        component: MyAddress,
      },
      {
        path: 'contact',
        name: 'Contact',
        component: Contact,
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
